module.exports = __webpack_public_path__ + "img/car-image.14cfd826.png";